
<template>
  <zm-modal
    ref="modal"
    @ok="handleSubmit"
    :title="title"
    :visible="visible"
    size="large"
    @cancel="open(false)"
  >
    <div slot="modalBody" class="result_application">
      <a-form :form="form">
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号">
              <span>{{ model.userName }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应聘岗位">
              <span>{{ model.departmentJobStr }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="实习岗">
              <span>{{ model.internship ? '是' : '否' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试官">
              <span>{{ model.interviewerName }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="base_info">
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预约时间">
              <span>{{ model.planInterviewTime }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="面试分数">
              <a-input
                style="width: calc(100% - 20px)"
                placeholder="请输入面试分数"
                autocomplete="off"
                :allowClear="true"
                v-decorator="['interviewScore', { rules: [{ required: true, message: '请输入面试分数！' }] }]"
              />
              <span style="display:inline-block;width:20px;text-align:right;">分</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="通过面试">
              <a-switch
                style="margin: 2px 8px 6px 0"
                size="small"
                :checked="form.getFieldValue('interviewResult')"
                v-decorator="['interviewResult', { rules: [{ required: true, message: '请选择是否通过面试！' }] }]"
              />
              <span>{{ form.getFieldValue('interviewResult') ? '通过' : '未通过' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="!form.getFieldValue('interviewResult')">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" hasFeedback>
              <a-textarea
                placeholder="请输入备注"
                :autosize="{ minRows: 4, maxRows: 6 }"
                v-decorator="['remarks', { rules: [{ required: true, message: '请填写备注！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="评分附件">
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                acceptType="txt,doc,docx,xls,xlsx,pdf,ppt,pptx,jpeg,jpg,png"
                @handleUpload="handleUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { applicationResult } from '@/api/applicant'
export default {
  name: 'resultApplication',
  components: {},
  data () {
    return {
      title: '操作',
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'resultApplication' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      colSpan: 12,

      headers: {
        Authorization: this.$store.state.user.token
      },
      fileList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.$nextTick(() => {
          this.form.setFieldsValue({ interviewResult: false })
        })
      } else {
        this.model = {}
      }
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          if (!this.fileList.length) {
            this.$message.warning('请上传评分附件！')
            return
          }
          const params = { ...value }
          params.intervieweeId = this.model.id
          params.interviewResult = params.interviewResult ? 2 : 3
          params.fileList = this.fileList
          this.$refs.modal.handleOkLoading(true)
          const res = await applicationResult(params).catch((error) => {
            this.$refs.modal.handleOkLoading(false)
            console.log('更新失败', error)
            this.$message.error('更新失败，请稍后重试！')
          })
          this.$refs.modal.handleOkLoading(false)
          if (res && res.status === 0) {
            this.$message.success(res.info.message)
            this.$emit('refreshTable')
            this.open(false)
          } else {
            this.$message.warning(res.info.message)
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
        this.fileList = []
        this.$refs.uploader.clearFileList()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    handleUpload (fileList) {
      this.fileList = fileList
    }
  }
}
</script>

<style lang="less">
.result_application{
  .base_info{
    .ant-form-item{
      margin-bottom: 0;

      .ant-form-item-label label{
        color: #B3B3B3;
      }
    }
  }
}
</style>

